import { Context } from './context'

export async function getCategoryAttachments (ctx: Context, categoriesIds: number[]) {
  const { prismaClient } = ctx
  const attachments = await prismaClient.attachment.findMany({
    where: {
      context: 'subforum',
      content_id: { in: categoriesIds }
    }
  })

  return attachments
}

export async function getAttachment (ctx: Context, attachmentId: number) {
  const { prismaClient } = ctx
  const attachments = await prismaClient.attachment.findFirst({
    where: {
      attachmentid: attachmentId
    }
  })

  return attachments
}
